<template>
  <v-container fluid class="d-flex flex-column">
    <v-row class="banner-liz">
      <div class="video-banner">
        <video autoplay muted loop playsinline>
          <source :src="videoSrc" type="video/mp4" />
          Tu navegador no soporta videos en HTML5.
        </video>
        <!-- <div class="overlay-content">
          <h1 class="banner-title">Bienvenido a Lavandería Liz</h1>
          <p class="banner-slogan">
            Tu ropa en buenas manos, siempre limpia y fresca.
          </p>
        </div> -->
      </div>
    </v-row>
    <v-row
      id="nosotros"
      class="section-nosotros section-granulated py-6"
      justify="center"
    >
      <v-col
        cols="12"
        md="6"
        class="d-flex flex-column justify-center align-center text-start"
      >
        <h2 class="subtitle-section">SOBRE NOSOTROS</h2>
        <br />
        <p>
          En Lavandería Liz contamos con más de 35 años de experiencia cuidando
          tus prendas con dedicación y calidad. Fundada en Huaraz por Rómulo y
          Zenaida, hoy somos la tercera generación comprometida con brindar un
          servicio de lavado, secado y planchado tanto personal como corporativo
          e industrial. Utilizamos maquinaria moderna que nos permite ofrecer un
          servicio express, manteniendo la calidad, color y frescura de cada
          prenda.
        </p>
      </v-col>
      <v-col cols="12" md="5">
        <v-img
          :src="imgAbout"
          class="w-100 rounded"
          aspect-ratio="1.6"
          cover
        ></v-img>
      </v-col>
    </v-row>
    <v-row id="clientes" class="section-clientes py-6" justify="center">
      <v-col
        cols="12"
        md="12"
        class="d-flex flex-column justify-center align-center"
      >
        <h2 class="subtitle-section">CLIENTES</h2>
      </v-col>
      <v-col cols="12" md="12">
        <v-carousel hide-delimiter-background show-arrows height="280">
          <v-carousel-item
            v-for="(group, index) in getImageChunks(images, imagesPerView)"
            :key="index"
          >
            <v-row justify="center" align="center">
              <v-col
                v-for="(img, i) in group"
                :key="i"
                cols="12"
                sm="6"
                md="4"
                class="d-flex justify-center"
              >
                <v-img
                  :src="require(`@/assets/LavanderiaLiz/Clientes/${img}`)"
                  max-width="220"
                  max-height="220"
                  cover
                  class="rounded"
                />
              </v-col>
            </v-row>
          </v-carousel-item>
        </v-carousel>
      </v-col>
    </v-row>
    <v-row id="servicios" class="section-servicios py-6" justify="center">
      <v-col cols="12" class="text-center">
        <h2 class="subtitle-section">NUESTROS SERVICIOS</h2>
      </v-col>
      <v-row justify="center" dense class="no-gutter">
        <v-col
          v-for="(service, index) in services"
          :key="index"
          cols="12"
          sm="6"
          md="4"
        >
          <v-hover v-slot="{ hover }">
            <v-card
              :elevation="hover ? 8 : 2"
              :class="hover ? 'hover-card' : ''"
              class="pa-0 transition-all card-compact rounded-lg"
              max-width="320"
            >
              <v-card-title class="title-overlay top-overlay">
                {{ service.title }}
              </v-card-title>
              <v-img
                height="180px"
                :src="require(`@/assets/LavanderiaLiz/${service.image}`)"
                class="align-end"
              >
              </v-img>

              <v-card-subtitle class="px-3 pt-2 pb-0 summary-color">
                {{ service.summary }}
              </v-card-subtitle>

              <v-card-text class="text-compact px-3 pb-3">
                {{ hover ? service.description : "" }}
              </v-card-text>
            </v-card>
          </v-hover>
        </v-col>
      </v-row>
    </v-row>
    <v-row id="contacto" class="section-contacto py-6" justify="center">
      <v-col cols="12" class="text-center">
        <h2 class="subtitle-section">CONTACTO</h2>
      </v-col>
      <v-row justify="center" class="no-gutter" dense>
        <v-col cols="12" md="6">
          <div class="section-content px-4">
            <h2>Escribenos</h2>
            <p
              style="
                border-left: 4px solid red;
                padding-left: 16px;
                margin-bottom: 16px;
              "
            >
              <strong>Teléfono:</strong> 981321905
            </p>

            <h2>Horario de atención</h2>
            <p
              style="
                border-left: 4px solid red;
                padding-left: 16px;
                margin-bottom: 16px;
              "
            >
              <strong>Lunes a Sábado</strong> 8:00 am - 8:00 pm
            </p>

            <h2>Dirección</h2>
            <p
              style="
                border-left: 4px solid red;
                padding-left: 16px;
                margin-bottom: 16px;
              "
            >
              <strong>Jirón Pedro Ruiz N° 403, Pueblo Libre</strong> A media
              cuadra de la Comisaría de Breña
            </p>
          </div>
        </v-col>
        <v-col cols="12" md="6">
          <div class="section-content">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d124852.87143930234!2d-77.20567230273433!3d-12.067431999999998!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9105c8e106996ad9%3A0x478cd1d08321afb9!2sLavander%C3%ADa%20Liz!5e0!3m2!1ses-419!2spe!4v1749149975082!5m2!1ses-419!2spe"
              width="100%"
              height="300"
              style="border: 0"
              allowfullscreen=""
              loading="lazy"
              referrerpolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </v-col>
      </v-row>
    </v-row>
    <a
      href="https://wa.me/51981321905"
      target="_blank"
      class="whatsapp-float"
      aria-label="Escríbenos por WhatsApp"
    >
      <img
        src="https://cdn-icons-png.flaticon.com/512/733/733585.png"
        alt="WhatsApp"
      />
    </a>
  </v-container>
</template>
<script>
export default {
  name: "HomePageComponent",
  data() {
    return {
      videoSrc: require('@/assets/LavanderiaLiz/film_banner.mp4'),
      imgAbout: require('@/assets/LavanderiaLiz/aboutLiz.jpg'),
      services: [
        {
          title: "Lavado al Agua / Seco / Teñido Textil",
          summary: "Diversos métodos según la prenda.",
          image: "Lavado al agua.jpg",
          description:
            "Ofrecemos lavado al agua, lavado en seco y teñido textil según el tipo de tela.",
        },
        {
          title: "Lavado por Kilo",
          summary: "Rápido y eficiente.",
          image: "Lavado ropa por Kilo.jpg",
          description:
            "Ideal para el día a día, grandes volúmenes de ropa a precio por kilo.",
        },
        {
          title: "Prendas Delicadas",
          summary: "Tratamiento especial.",
          image: "Ropa delicada.jpg",
          description:
            "Ternos, vestidos de gala y de novia con cuidado profesional.",
        },
        {
          title: "Ropa de Cama",
          summary: "Frescura y limpieza.",
          image: "Ropa de cama.jpg",
          description: "Lavado de sábanas, frazadas, edredones y colchas.",
        },
        /* {
          title: "Ropa de Sala",
          summary: "Hogar impecable.",
          image: "",
          description: "Lavado de cortinas, sofá, fundas y manteles.",
        }, */
        {
          title: "Lavado de Ternos",
          summary: "Materiales delicados.",
          image: "Lavado de Terno.jpg", // suponiendo que ya tienes la imagen
          description:
            "Lavado y cuidado especializado para ternos, chaquetas y ropa formal, preservando su forma y textura original.",
        },
        {
          title: "Zapatillas y Accesorios",
          summary: "Calzado limpio.",
          image: "Lavadp zapatillas.jpg",
          description: "Lavado de zapatillas, carteras y artículos de cuero.",
        },
        /* {
          title: "Secado",
          summary: "Listo para usar.",
          image: "",
          description:
            "Secado industrial eficiente, cuidando la forma y textura de tus prendas.",
        }, */
        {
          title: "Planchado",
          summary: "Toque final.",
          image: "Planchado.jpg",
          description: "Planchado profesional para que tu ropa luzca perfecta.",
        },
        {
          title: "🐾 Servicio para Mascotas",
          summary: "Perfecto a tus engreídos.",
          image: "Ropa de perro.jpg",
          description:
            "Lavado de ropa, mantas y accesorios de tus mascotas con productos seguros.",
        },
      ],
      images: [
        "La_Panera.png",
        "contonga.png",
        "Lincuna.png",
        "logo_sanpablo_huaraz.png",
        "Essalud_Hz.png",
        "Colegio_mayor_coar_logo.png",
      ],
    };
  },
  computed: {
    gruposDeImagenes() {
      const chunkSize = 3;
      const result = [];
      for (let i = 0; i < this.imagenes.length; i += chunkSize) {
        result.push(this.imagenes.slice(i, i + chunkSize));
      }
      return result;
    },
    imagesPerView() {
      if (this.$vuetify.breakpoint.xs) return 1;
      if (this.$vuetify.breakpoint.sm) return 2;
      return 3;
    },
  },
  methods: {
    getImageChunks(images, size) {
      const chunks = [];
      for (let i = 0; i < images.length; i += size) {
        chunks.push(images.slice(i, i + size));
      }
      return chunks;
    },
  },
};
</script>
<style>
@import url("https://fonts.googleapis.com/css2?family=Baloo+2:wght@400..800&family=Barlow+Condensed:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Quicksand:wght@300..700&display=swap");
.banner-title {
  font-size: 4.2rem;
  font-weight: bold;
  text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.7);
}

.banner-liz {
  background-color: aqua;
  min-height: 360px;
}
.banner-slogan {
  font-size: 1.2rem;
  color: var(--white);
  margin-top: 0.5rem;
  text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.7);
}
.no-gutter > .v-col {
  padding-left: 4px !important;
  padding-right: 4px !important;
}
.section-content {
  max-width: 600px;
  margin: 0 auto;
}
.section-nosotros {
  background-color: var(--light-blue-bg);
}
.section-nosotros .subtitle-section {
  color: var(--primary-blue); /* excelente contraste */
}
.section-servicios {
  background-color: var(--white);
}
.section-servicios .subtitle-section {
  color: var(--primary-blue); /* legible y corporativo */
}
.section-contacto {
  background-color: var(--soft-red-bg);
}
.section-contacto .subtitle-section {
  color: #dc3545; /* rojo fuerte para resaltar */
}
.card-compact {
  max-width: 320px;
  margin: 0 auto; /* centra la card dentro del col */
  min-height: 180px;
}
.title-overlay {
  background: transparent !important;
  padding-left: 10px;
  font-weight: 600;
  font-size: 1.15rem;
  color: var(--dark-blue);
  text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.6);
}

.subtitle-section {
  color: var(--dark-blue);
  font-family: "Baloo 2", cursive;
  font-size: 2.2rem;
  font-weight: 900;
  text-align: center;
  margin-bottom: 1.5rem;
  text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.6);
}
.summary-color {
  color: var(--light-blue-bg);
  font-weight: 900;
  font-size: 0.99rem;
}
.text-compact {
  font-size: 0.85rem;
  font-weight: 600;
  min-height: 40px;
  transition: opacity 0.3s ease;
  color: var(--dark-blue) !important;
  font-family: "Roboto Condensed", sans-serif;
}
.hover-card {
  background-color: #f9f9f9;
  transform: scale(1.03);
  transition: all 0.3s ease;
}
.transition-all {
  transition: all 0.3s ease;
}

.video-banner {
  position: relative;
  width: 100%;
  height: 80vh; /* o una altura fija como 400px */
  overflow: hidden;
}

.video-banner video {
  position: absolute;
  top: 50%;
  left: 50%;
  min-width: 100%;
  min-height: 100%;
  transform: translate(-50%, -50%);
  object-fit: cover;
  z-index: 1;
}

.overlay-content {
  position: relative;
  z-index: 2;
  color: white;
  text-align: left;
  padding-top: 30vh;
  padding-left: 2rem;
}

.whatsapp-float {
  position: fixed;
  width: 60px;
  height: 60px;
  bottom: 20px;
  right: 20px;
  background-color: #25d366;
  color: white;
  border-radius: 50%;
  text-align: center;
  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.3);
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
}

.whatsapp-float img {
  width: 35px;
  height: 35px;
}

.section-granulated {
  position: relative;
  background-color: var(--light-blue-bg); /* Tu color base */
  overflow: hidden;
  z-index: 0;
}

.section-granulated::before {
  content: "";
  position: absolute;
  inset: 0;
  background-image: radial-gradient(rgb(0, 45, 114) 1px, transparent 1px);
  background-size: 3px 3px;
  opacity: 0.2; /* Más visible */
  pointer-events: none;
  z-index: 1; /* Misma capa que el fondo */
}

.section-granulated > * {
  position: relative;
  z-index: 2;
}
</style>
